export default __webpack_public_path__ + "static/media/bixosoft.0b0b613e.png";